import { AnyAction } from "redux";
import { HardwareState } from "../../../../../models/state";
import { fulfilled } from "../../../checkout/utils";
import * as AT from "../actionTypes";

const initialState: HardwareState = {
    lookedUpProducts: undefined,
    selectedEan: undefined,
};

const hardwareReducer = (state = initialState, action: AnyAction): HardwareState => {
    switch (action.type) {
        case fulfilled(AT.RETAILER_FETCH_PRODUCT_BY_EAN): {
            return {
                ...state,
                lookedUpProducts: action.payload?.products,
                selectedEan: action.payload?.selectedEan,
            };
        }
        case AT.RETAILER_SET_SELECTED_EAN: {
            return {
                ...state,
                selectedEan: action.ean,
            };
        }

        default:
            return state;
    }
};

export default hardwareReducer;
